import moment from "moment";
import { SubscriptionTierEnum } from "../enums/SubscriptionTier";
import { IUser } from "../interfaces/user.interface";
import { getUserSubscriptionInfo } from "../services/user/user.service";

export const isUserFreeTrialEnded = async (
    user: IUser | null | undefined
): Promise<boolean> => {
    if (!user || !user.freeTrialEndsAt) return false;

    if (
        user?.organization?.isArchived ||
        user.subscriptionTier === SubscriptionTierEnum.FREE ||
        moment(user?.freeTrialEndsAt).isBefore(moment())
    ) {
        return true;
    }

    if (
        user?.organization?.freeTrialEndDate &&
        moment(user?.organization?.freeTrialEndDate).isBefore(moment())
    ) {
        return true;
    }

    try {
        const { response } = await getUserSubscriptionInfo();

        if (response && response?.status !== "active") {
            return true;
        }

        return false;
    } catch (err) {
        return true;
    }
};
